export const configTypes = {
  CUSTOM_FIELDS_FOR_MODEL: 'configCustomFieldsForModel',
  IN_COMPLIANCE_REPORTING_PERIOD: 'inComplianceReportingPeriod',
  RESOURCES_CATEGORIES: 'resourcesCategories',
  TICKET_GIVEAWAY_HTML: 'ticketGiveawayHtml',
};
